module.exports = __webpack_public_path__ + "img/Zerstört.b31166fb.svg";